export default __webpack_public_path__ + "static/media/split-promotional-header-background-desktop.7514e318.svg";